import { render } from "./SaleChannelForm.vue?vue&type=template&id=4c561c70"
import script from "./SaleChannelForm.vue?vue&type=script&lang=js"
export * from "./SaleChannelForm.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__